import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  const { t } = useLanguage();

  const translateCategory = useMemo(() => {
    return (category) => {
      if (category === 'all') return t('todos');
      
      const categoryMap = {
        'Investigación': t('investigacion'),
        'Texto y redacción': t('texto-redaccion'),
        'Educación': t('educacion'),
        'Chatbots': t('chatbots'),
        'Video': t('video'),
        'Mapas mentales': t('mapas-mentales'),
        'Imágenes': t('imagenes'),
        'Diseño': t('diseno'),
        'Generador de asistentes virtuales': t('generador-asistentes'),
        'Detector de contenidos de IA': t('detector-contenidos'),
        'Música': t('musica'),
        'Motores de búsqueda': t('motores-busqueda'),
        'Audio': t('audio'),
        'Redes sociales': t('redes-sociales')
      };
      return categoryMap[category] || category;
    };
  }, [t]);

  const sortedCategories = useMemo(() => {
    return categories.sort((a, b) => {
      if (a === 'all') return -1;
      if (b === 'all') return 1;
      return translateCategory(a).localeCompare(translateCategory(b));
    });
  }, [categories, translateCategory]);

  const handleCategoryClick = (category) => {
    onCategoryChange(category);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="mb-8"
    >
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-3 text-center">
        {t('filtrar-categoria')}
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        {sortedCategories.map((category) => (
          <motion.button
            key={category}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => handleCategoryClick(category)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
              selectedCategory === category
                ? 'bg-blue-600 text-white shadow-lg'
                : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
            }`}
          >
            {translateCategory(category)}
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default CategoryFilter;